import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { PlugAvatar } from '../../components/PlugAvatar';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Up next; each part uses its own slice of it */
import styles from './UpNext.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Plug with a slow pulse ring (design s: "Plug is working"); `idle` breathes slower. */
const PlugPulseComponent: React.FC<{ size?: 16 | 24 | 40; idle?: boolean }> = ({ size = 24, idle = false }) => (
  <span className={clsx(styles.plug, idle && styles.plugIdle)} aria-hidden>
    <PlugAvatar size={size} state="busy" />
  </span>
);

export const PlugPulse = TypedMemo(PlugPulseComponent);
